// ============================================================================
// KOREAN TRANSLATIONS - CHAPTER 3: 예수 그리스도
// ============================================================================
// 레벨 27-39 (13 레벨, 39 질문)

export const chapter3Translations = {
  name: '예수 그리스도',
  description: '말씀이 육신이 되시니라... 그리스도를 아는 것이 영생이니라',
  
  spiritualWisdom: {
    principle: '예수 그리스도를 아는 것이 영생이니라',
    scripture: '영생은 곧 유일하신 참 하나님과 그가 보내신 자 예수 그리스도를 아는 것이니이다 (요한복음 17:3)',
    application: '예수님의 삶의 모든 면이 하나님을 계시하고 영원을 위해 우리 영혼을 양육한다'
  },
  
  levels: {
    27: {
      name: '수태고지',
      challenge: '천사 가브리엘이 하나님께로부터 보내심을 받아 갈릴리 한 동네로...',
      easy: {
        question: '마리아에게 예수님을 잉태할 것을 알린 천사는 누구입니까?',
        options: ['미카엘', '가브리엘', '라파엘', '우리엘'],
        hint: '하나님의 사자 천사',
        funFact: '👼 가브리엘은 하나님의 능력이라는 뜻 - 위대한 선포의 천사!'
      },
      medium: {
        question: '이 고지에 대한 마리아의 첫 반응은 무엇이었습니까?',
        options: [
          '즉각적인 기쁨',
          '완전한 불신',
          '혼란과 어찌 이런 일이 있으리이까라는 질문',
          '두려움'
        ],
        hint: '실용적이고 정당한 질문',
        funFact: '🤔 마리아는 논리적인 질문을 하지만 하나님께 열린 마음을 유지한다!'
      },
      hard: {
        question: '마리아의 하나님 뜻에 대한 순종은 무엇을 가르쳐 줍니까?',
        options: [
          '시련 앞에서의 수동성',
          '모든 것을 이해하지 못해도 신뢰하는 믿음',
          '맹목적 순종',
          '체념'
        ],
        hint: '미지의 것 속에서도 하나님을 신뢰하는 것에 관한 것',
        funFact: '🙏 주의 말씀대로 내게 이루어지이다 - 신뢰하는 믿음의 모범!'
      }
    },
    
    28: {
      name: '탄생',
      challenge: '첫아들을 낳아 강보로 싸서 구유에 뉘었으니...',
      easy: {
        question: '예수님은 어느 도시에서 태어나셨습니까?',
        options: ['나사렛', '예루살렘', '베들레헴', '가버나움'],
        hint: '다윗의 성',
        funFact: '🏘️ 베들레헴은 떡집이라는 뜻 - 예수님, 생명의 떡!'
      },
      medium: {
        question: '탄생 소식을 처음 받은 사람들은 누구입니까?',
        options: [
          '동방박사들',
          '들에 있는 목자들',
          '성전의 제사장들',
          '마리아의 가족'
        ],
        hint: '양떼를 지키던 평범한 사람들',
        funFact: '🐑 하나님은 먼저 겸손한 목자들에게 알리신다 - 모든 사람을 위한 복음!'
      },
      hard: {
        question: '구유에 나신 예수님은 무엇을 상징합니까?',
        options: [
          '부모의 가난',
          '우리에게까지 낮아지시는 하나님의 겸손',
          '공간 부족',
          '시골의 소박함'
        ],
        hint: '겸손 속의 신성한 성육신에 관한 것',
        funFact: '👶 우주의 창조주가 마구간에서 태어나신다 - 무한한 사랑!'
      }
    },

    29: {
      name: '동방박사',
      challenge: '동방으로부터 박사들이 예루살렘에 와서 물어...',
      easy: {
        question: '박사들을 예수님께로 인도한 것은 무엇입니까?',
        options: ['천사', '별', '환상', '지도'],
        hint: '하늘의 천체',
        funFact: '⭐ 별은 예수님이 민족들의 빛이심을 나타낸다!'
      },
      medium: {
        question: '박사들이 드린 예물은 무엇입니까?',
        options: [
          '음식',
          '황금, 유향, 몰약',
          '귀한 옷',
          '장난감'
        ],
        hint: '상징적이고 귀한 세 가지 선물',
        funFact: '🎁 황금(왕권), 유향(신성), 몰약(희생) - 예수님의 모든 사명!'
      },
      hard: {
        question: '이 이방인 박사들은 하나님의 계획에서 무엇을 나타냅니까?',
        options: [
          '다른 종교의 우월성',
          '모든 민족에게 제공되는 구원의 보편성',
          '물질적 부',
          '고대 과학'
        ],
        hint: '모든 나라를 위한 구원의 개방에 관한 것',
        funFact: '🌍 박사들은 온 세상에 이를 복음을 예시한다!'
      }
    },

    30: {
      name: '예수님의 세례',
      challenge: '예수께서 세례를 받으시고 곧 물에서 올라오실새...',
      easy: {
        question: '예수님께 세례를 준 사람은 누구입니까?',
        options: ['베드로', '세례 요한', '안드레', '야고보'],
        hint: '예수님의 선구자',
        funFact: '🌊 세례 요한은 예수님의 신발 끈을 풀기도 감당하지 못한다고 여겼다!'
      },
      medium: {
        question: '세례 때 예수님 위에 무엇이 내려왔습니까?',
        options: [
          '빛',
          '비둘기(성령)',
          '천사',
          '음성만'
        ],
        hint: '평화의 상징인 새',
        funFact: '🕊️ 비둘기는 사역을 시작하기 위한 신성한 기름부음을 나타낸다!'
      },
      hard: {
        question: '죄 없으신 예수님이 왜 세례를 받으셨습니까?',
        options: [
          '모범을 보이기 위해',
          '모든 의를 이루고 우리와 동일시하기 위해',
          '종교적 의무 때문에',
          '용서를 받기 위해'
        ],
        hint: '죄 많은 인류와의 연대에 관한 것',
        funFact: '❤️ 예수님은 우리를 더 잘 구원하시기 위해 우리와 완전히 동일시하신다!'
      }
    },

    31: {
      name: '광야의 시험',
      challenge: '예수께서 성령에게 이끌리어 마귀에게 시험을 받으러 광야로 가사...',
      easy: {
        question: '예수님은 광야에서 얼마나 금식하셨습니까?',
        options: ['30일', '40일', '50일', '60일'],
        hint: '시험의 성경적 숫자',
        funFact: '🏜️ 모세와 엘리야처럼 40일간의 집중적인 영적 준비!'
      },
      medium: {
        question: '예수님은 각 시험을 어떻게 물리치셨습니까?',
        options: [
          '자신의 힘으로',
          '성경을 인용하여',
          '사탄을 무시하여',
          '기도만으로'
        ],
        hint: '탁월한 영적 무기',
        funFact: '📖 기록되었으되... - 하나님의 말씀, 성령의 검!'
      },
      hard: {
        question: '예수님의 시험은 우리의 싸움에 대해 무엇을 가르쳐 줍니까?',
        options: [
          '시험은 죄이다',
          '시험은 말씀과 믿음으로 이길 수 있다',
          '모든 광야에서 도망쳐야 한다',
          '예수님만 저항할 수 있다'
        ],
        hint: '시험에 대한 우리의 전략에 관한 것',
        funFact: '⚔️ 예수님은 승리하는 방법을 보여주신다: 하나님의 말씀 + 적극적 믿음!'
      }
    },

    32: {
      name: '첫 제자들',
      challenge: '예수께서 이르시되 나를 따라오라 내가 너희를 사람을 낚는 어부가 되게 하리라...',
      easy: {
        question: '베드로와 안드레의 직업은 무엇이었습니까?',
        options: ['목자', '어부', '목수', '세리'],
        hint: '갈릴리 호수의 직업',
        funFact: '🎣 예수님은 물고기 잡는 어부를 영혼 낚는 어부로 변화시키신다!'
      },
      medium: {
        question: '첫 제자들은 부르심에 어떻게 반응했습니까?',
        options: [
          '오랫동안 망설였다',
          '증거를 요구했다',
          '모든 것을 버리고 즉시 따랐다',
          '협상했다'
        ],
        hint: '즉각적이고 완전한 반응',
        funFact: '🚶 예수님의 권위가 너무 명백해서 즉시 순종했다!'
      },
      hard: {
        question: '우리 시대에 예수님을 따르는 것은 무엇을 의미합니까?',
        options: [
          '일을 그만두는 것',
          '그분의 가르침과 뜻대로 사는 것',
          '고립된 공동체에 가입하는 것',
          '전도만 하는 것'
        ],
        hint: '삶과 우선순위의 변화에 관한 것',
        funFact: '✨ 예수님을 따르는 것은 우리의 마음, 선택, 운명을 변화시킨다!'
      }
    },

    33: {
      name: '산상수훈',
      challenge: '마음이 가난한 자는 복이 있나니, 천국이 그들의 것임이라...',
      easy: {
        question: '산상수훈의 첫 번째 복은 무엇입니까?',
        options: [
          '마음이 청결한 자는 복이 있나니',
          '마음이 가난한 자는 복이 있나니',
          '온유한 자는 복이 있나니',
          '화평하게 하는 자는 복이 있나니'
        ],
        hint: '영적 겸손에 관한 것',
        funFact: '😊 마음이 가난한 자는 하나님이 필요함을 압니다 - 천국의 문!'
      },
      medium: {
        question: '화평하게 하는 자에 대해 예수님은 무엇이라 하셨습니까?',
        options: [
          '그들이 행운을 얻을 것이다',
          '그들이 하나님의 아들이라 일컬음을 받을 것이요',
          '그들이 사랑받을 것이다',
          '그들이 강해질 것이다'
        ],
        hint: '특별한 하나님의 정체성',
        funFact: '👑 평화를 만드는 자는 하나님을 닮았습니다 - 그분 본성의 살아있는 증거!'
      },
      hard: {
        question: '팔복은 세상의 가치관을 어떻게 뒤집습니까?',
        options: [
          '부를 비난함으로써',
          '신자들을 고립시킴으로써',
          '세상이 멸시하는 자들에게 복이 있다고 선포함으로써',
          '율법을 폐함으로써'
        ],
        hint: '세속적 가치관과 반대되는 하나님의 가치관에 관한 것',
        funFact: '🔄 팔복은 행복과 성공에 대한 우리의 시각을 바꿉니다!'
      }
    },

    34: {
      name: '천국 비유',
      challenge: '예수께서 비유로 여러 가지를 그들에게 가르치셨다...',
      easy: {
        question: '씨 뿌리는 자의 비유에서 씨는 무엇을 나타냅니까?',
        options: [
          '돈',
          '하나님의 말씀',
          '선행',
          '사랑'
        ],
        hint: '예수께서 선포하시고 가르치시는 것',
        funFact: '🌱 하나님의 말씀이 우리 마음에서 싹트고 자랍니다!'
      },
      medium: {
        question: '겨자씨 비유에서, 이 작은 씨는 무엇을 상징합니까?',
        options: [
          '인간의 연약함',
          '작게 시작하지만 크게 자라는 천국',
          '세부사항의 중요성',
          '자연'
        ],
        hint: '인상적으로 성장하는 것',
        funFact: '🌳 가장 작은 씨에서 큰 나무가 생깁니다 - 천국의 능력!'
      },
      hard: {
        question: '예수님은 왜 비유로 가르치셨습니까?',
        options: [
          '메시지를 복잡하게 하기 위해',
          '친숙한 이미지로 영적 진리를 드러내기 위해',
          '시간이 부족해서',
          '지능을 테스트하기 위해'
        ],
        hint: '천국의 비밀을 접근 가능하게 만드는 것에 관한 것',
        funFact: '💡 비유는 열린 마음에는 드러내고 닫힌 마음에는 숨깁니다!'
      }
    },

    35: {
      name: '예수님의 기적',
      challenge: '예수께서 폭풍을 잠잠하게 하시고 바다에게 말씀하시되: 잠잠하라! 고요하라!...',
      easy: {
        question: '예수님은 몇 개의 떡으로 5천 명을 먹이셨습니까?',
        options: ['떡 3개', '떡 5개', '떡 7개', '떡 12개'],
        hint: '물고기와 같은 수',
        funFact: '🍞 떡 5개와 물고기 2마리가 잔치가 됩니다 - 하나님의 관대하심!'
      },
      medium: {
        question: '예수님이 폭풍을 잠잠하게 하셨을 때 제자들이 무엇이라 했습니까?',
        options: [
          '그는 마술사다',
          '바람과 바다도 순종하는 이가 누구냐?',
          '정상이다',
          '우리는 여기를 떠나야 한다'
        ],
        hint: '예수님의 정체성에 관한 질문',
        funFact: '⛈️ 자연의 요소들도 창조주이자 주님을 알아봅니다!'
      },
      hard: {
        question: '예수님의 기적의 주요 목적은 무엇입니까?',
        options: [
          '군중에게 깊은 인상을 주기 위해',
          '그분의 신성을 드러내고 하나님의 사랑을 나타내기 위해',
          '영향력을 얻기 위해',
          '물질적으로만 돕기 위해'
        ],
        hint: '신성한 계시와 자비에 관한 것',
        funFact: '❤️ 모든 기적은 하나님의 마음을 드러냅니다: 사랑, 자비, 능력!'
      }
    },

    36: {
      name: '변화산',
      challenge: '그들 앞에서 변형되시니 그 얼굴이 해 같이 빛나며...',
      easy: {
        question: '어떤 제자들이 예수님의 변화를 보았습니까?',
        options: [
          '열두 명 모두',
          '베드로, 야고보, 요한',
          '베드로와 요한만',
          '예수님을 따르던 여인들'
        ],
        hint: '세 명의 내부 서클',
        funFact: '⛰️ 베드로, 야고보, 요한: 하나님의 영광의 특권 있는 증인들!'
      },
      medium: {
        question: '구약의 어떤 인물들이 나타났습니까?',
        options: [
          '아브라함과 이삭',
          '다윗과 솔로몬',
          '모세와 엘리야',
          '아담과 노아'
        ],
        hint: '율법의 대표와 선지자의 대표',
        funFact: '📜 모세(율법)와 엘리야(선지자)가 예수님을 증거합니다!'
      },
      hard: {
        question: '이 변화는 예수님의 본성에 대해 무엇을 드러냅니까?',
        options: [
          '위대한 선지자이시다',
          '숨겨진 신성이 일시적으로 드러난다',
          '빛을 통제하신다',
          '모습을 바꿀 수 있다'
        ],
        hint: '그분의 신성한 본성의 계시에 관한 것',
        funFact: '✨ 예수님의 하나님의 영광이 빛납니다 - 부활의 예고!'
      }
    },

    37: {
      name: '승리의 입성',
      challenge: '다윗의 자손에게 호산나! 주의 이름으로 오시는 이여 찬송하리로다!...',
      easy: {
        question: '예수님은 어떤 동물을 타고 예루살렘에 입성하셨습니까?',
        options: ['말', '나귀', '낙타', '걸어서'],
        hint: '겸손과 평화의 상징인 동물',
        funFact: '🐴 나귀는 전쟁이 아닌 평화로 오시는 겸손한 왕을 상징합니다!'
      },
      medium: {
        question: '예수님을 맞이하는 군중이 무엇이라 외쳤습니까?',
        options: [
          '왕 만세!',
          '호산나! 주의 이름으로 오시는 이여 찬송하리로다!',
          '하나님께 영광!',
          '자유를!'
        ],
        hint: '기쁨과 축복의 외침',
        funFact: '🌿 "호산나"는 "지금 구원하소서"라는 뜻 - 하나님의 구원을 위한 부름!'
      },
      hard: {
        question: '왜 이 입성은 "승리"이지만 비극적입니까?',
        options: [
          '사람이 적었다',
          '환영하는 군중이 5일 후에 거절할 것이다',
          '당국이 없었다',
          '비가 내렸다'
        ],
        hint: '인간 마음의 변덕에 관한 것',
        funFact: '💔 같은 군중이 며칠 후 "십자가에 못 박으라!"고 외칠 것입니다!'
      }
    },

    38: {
      name: '최후의 만찬',
      challenge: '받아 먹으라, 이것은 너희를 위하여 주는 내 몸이니라...',
      easy: {
        question: '예수님은 제자들의 발에 무엇을 하셨습니까?',
        options: [
          '축복하셨다',
          '씻으셨다',
          '향유를 바르셨다',
          '입맞추셨다'
        ],
        hint: '겸손과 섬김의 행위',
        funFact: '🦶 스승이 종이 되십니다 - 사랑과 겸손의 혁명!'
      },
      medium: {
        question: '이 만찬에서 예수님은 무엇을 제정하셨습니까?',
        options: [
          '세례',
          '성찬식',
          '주기도문',
          '금식'
        ],
        hint: '떡과 포도주를 사용하는 성례',
        funFact: '🍞🍷 떡과 포도주가 희생과 사랑의 영원한 상징이 됩니다!'
      },
      hard: {
        question: '"나를 기념하여 이를 행하라"는 무슨 뜻입니까?',
        options: [
          '이 만찬을 반복하라',
          '내가 다시 올 때까지 내 죽음과 부활을 기념하라',
          '내 말을 기억하라',
          '서로 사랑하라'
        ],
        hint: '살아있고 예언적인 기념에 관한 것',
        funFact: '⏳ 모든 성찬식은 주님이 오실 때까지 주의 죽으심을 전합니다!'
      }
    },

    39: {
      name: '겟세마네',
      challenge: '내 아버지여, 할 수만 있으면 이 잔을 내게서 지나가게 하옵소서...',
      easy: {
        question: '예수님은 체포되기 전에 어디서 기도하셨습니까?',
        options: [
          '성전에서',
          '겟세마네 동산에서',
          '감람산에서',
          '친구 집에서'
        ],
        hint: '올리브 나무 동산',
        funFact: '🫒 겟세마네는 "기름 짜는 곳"을 의미합니다 - 극심한 압박의 장소!'
      },
      medium: {
        question: '예수님이 기도하시는 동안 제자들은 무엇을 했습니까?',
        options: [
          '함께 기도했다',
          '잠들었다',
          '파수를 섰다',
          '떠나갔다'
        ],
        hint: '한 시간도 깨어 있을 수 없었다',
        funFact: '😴 마음은 원하나 육신이 약하도다 - 인간의 연약함!'
      },
      hard: {
        question: '예수님의 고뇌는 그분의 본성에 대해 무엇을 드러냅니까?',
        options: [
          '단지 인간이셨다',
          '온전한 인간이시며 온전한 하나님이시다',
          '사명을 의심하셨다',
          '약하셨다'
        ],
        hint: '성육신의 신비에 관한 것',
        funFact: '✝️ 예수님은 하나님께 충성하시면서 인간의 고뇌를 온전히 짊어지십니다!'
      }
    }
  }
};

export default chapter3Translations;
